import { render, staticRenderFns } from "./ex-company-details.vue?vue&type=template&id=3b54e335&scoped=true&"
import script from "./ex-company-details.vue?vue&type=script&lang=js&"
export * from "./ex-company-details.vue?vue&type=script&lang=js&"
import style0 from "./ex-company-details.vue?vue&type=style&index=0&id=3b54e335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54e335",
  null
  
)

export default component.exports